module.exports = __webpack_public_path__ + "static/media/logo-mixabl.9e3db61f.svg";